import { render, staticRenderFns } from "./GestionCesionesPlazas.vue?vue&type=template&id=2c493330&"
import script from "./GestionCesionesPlazas.vue?vue&type=script&lang=js&"
export * from "./GestionCesionesPlazas.vue?vue&type=script&lang=js&"
import style0 from "./GestionCesionesPlazas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VIcon,VTab,VTabs})
